import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/manifold-logograph.svg'


const _withScopeId = n => (_pushScopeId("data-v-3ffd567e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "error-container" }
const _hoisted_2 = { class: "error" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Error"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Something went wrong", -1))
const _hoisted_5 = {
  key: 0,
  class: "message"
}

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ErrorPage',
  props: {
    error: {}
  },
  setup(__props: any) {

const props = __props;


const message = computed(() => {
  const e = props.error;

  if (!e) {
    return 'Unexpected error';
  }

  if (e.message) {
    return props.error.message;
  } else if (e.error) {
    return e.error;
  } else if (typeof e === 'string') {
    return e;
  }

  return '';
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      (message.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(message.value), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})